






























































import { Vue, Component } from 'vue-property-decorator'
import marked from 'marked'

import News from '@/assets/information.yaml'

@Component
export default class InformationDetailView extends Vue {
    markdownHtml(source: string) {
        return marked(source)
    }

    get news() {
        const matchedNews = News.content.filter(x => x.id.toString() == this.$route.params["id"])
        if (matchedNews.length > 0) {
            return matchedNews[0]
        } else {
            return null
        }
    }
}
